import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  ALL_SERVICES,
  REQUESTED_CATEGORIES_URL_PARAM_NAME,
} from '../../consts';
import {
  enrichServices,
  filterServicesBySelectedTab,
} from '../../utils/services/services';
import {
  EnrichedService,
  FilterOption,
  FilterServicesByOptions,
} from '../../types/types';
import { WidgetViewModel } from '../../viewModel/viewModel';
import settingsParams from '../../components/BookOnline/settingsParams';
import {
  BookingsQueryParams,
  setUrlQueryParam,
} from '@wix/bookings-catalog-calendar-viewer-utils';
import { BookingsAPI } from '../../api/BookingsApi';
import { getAdditionalServicesData } from '../getAdditionalServicesData/getAdditionalServicesData';

export type OnFilterOptionSelectedAction = (
  selectedFilterOption: FilterOption,
) => void;

export const createOnFilterOptionSelectedAction = ({
  widgetViewModel,
  services: previousServices,
  setProps,
  flowAPI,
  bookingsApi,
  activeFeatures,
  isPricingPlanInstalled,
  serviceListContext,
}: {
  services: EnrichedService[];
  widgetViewModel: WidgetViewModel;
  setProps: Function;
  flowAPI: ControllerFlowAPI;
  bookingsApi: BookingsAPI;
  activeFeatures: any;
  isPricingPlanInstalled: boolean;
  serviceListContext: any;
}): OnFilterOptionSelectedAction => {
  return async (selectedFilterOption: FilterOption) => {
    const {
      settings,
      controllerConfig: { wixCodeApi },
      experiments,
    } = flowAPI;
    const filterServicesBy = settings.get(settingsParams.filterServicesBy);
    const fetchTabsInServiceListEnabled = experiments.enabled(
      'specs.bookings.fetchTabsInServiceList',
    );
    if (
      fetchTabsInServiceListEnabled &&
      selectedFilterOption.id === ALL_SERVICES
    ) {
      wixCodeApi.location.queryParams.remove([
        REQUESTED_CATEGORIES_URL_PARAM_NAME,
        BookingsQueryParams.LOCATION,
      ]);
    } else if (filterServicesBy === FilterServicesByOptions.CATEGORIES) {
      setUrlQueryParam({
        wixCodeApi,
        key: REQUESTED_CATEGORIES_URL_PARAM_NAME,
        value: selectedFilterOption.id,
      });
    } else if (
      fetchTabsInServiceListEnabled &&
      filterServicesBy === FilterServicesByOptions.LOCATIONS
    ) {
      setUrlQueryParam({
        wixCodeApi,
        key: BookingsQueryParams.LOCATION,
        value: selectedFilterOption.id,
      });
    }

    const newFilterOptions = widgetViewModel.filterOptions.map(
      (filterOption: FilterOption) => ({
        ...filterOption,
        isSelected: filterOption.id === selectedFilterOption.id,
      }),
    );

    if (fetchTabsInServiceListEnabled) {
      bookingsApi.queryServices().then(async (queryServicesResponse) => {
        const services = queryServicesResponse.data.services || [];
        const enrichedServices = await enrichServices({
          flowAPI,
          activeFeatures,
          isPricingPlanInstalled,
          services,
          isAnywhereFlow: serviceListContext.isAnywhereFlow,
        });
        const { coursesAvailability, services: populatedServices } =
          await getAdditionalServicesData({
            bookingsApi,
            services: enrichedServices,
          });

        widgetViewModel.filterOptions = newFilterOptions;
        widgetViewModel.services = populatedServices;
        widgetViewModel.coursesAvailability = coursesAvailability;

        setProps({
          widgetViewModel: { ...widgetViewModel },
        });
      });
    } else {
      const servicesToDisplay = filterServicesBySelectedTab({
        filterOptions: newFilterOptions,
        services: previousServices,
        settings,
      });

      const { coursesAvailability, services: populatedServices } =
        await getAdditionalServicesData({
          bookingsApi,
          services: servicesToDisplay,
        });

      widgetViewModel.filterOptions = newFilterOptions;
      widgetViewModel.services = populatedServices;
      widgetViewModel.coursesAvailability = coursesAvailability;

      setProps({
        widgetViewModel: { ...widgetViewModel },
      });
    }
  };
};
